import {DomesticShipment, type DomesticShipmentData} from "@/types/shipments/Domestic/DomesticShipment.ts";

export class DomesticRoadShipmentTrackingUrl {
    public id:number|null;
    public domestic_shipment_id:number;
    public guid:string;
    public shipment: DomesticShipment | null;

    constructor(data:DomesticRoadShipmentTrackingUrlData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.domestic_shipment_id = 0;
            this.guid = "";
            this.shipment = null;
        }
        else
        {
            this.id = data.id;
            this.domestic_shipment_id = data.domestic_shipment_id;
            this.guid = data.guid;
            this.shipment = null;
            if (data.shipment !== undefined && data.shipment !== null) {
                this.shipment = new DomesticShipment(data.shipment)
            }
        }
    }
}

export type DomesticRoadShipmentTrackingUrlData = {
    id:number|null;
    domestic_shipment_id:number;
    guid:string;
    shipment: DomesticShipmentData | null;
}